<template>
    <div class="iframeContainer">
        <div v-if="iframeLoading">
            <md-progress-spinner class="md-accent" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <iframe
            v-if="getCustomerClientAddress()"
            class="mt-2"
            sandbox="allow-forms allow-top-navigation allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-scripts"
            frameborder="0"
            loading="eager"
            style="height: 500px"
            :src="getCustomerClientAddress()"
            @load="iframeLoading = false"
        />
        <BubblePreview class="message-baloon" />
    </div>
</template>

<script>
import BubblePreview from "./BubblePreview.vue";
import { mapActions, mapState } from "vuex";
import { PRODUCTION } from "../../utils/utils";

export default {
    name: "LivePreview",
    components: {
        BubblePreview,
    },
    data() {
        return {
            iframeLoading: true,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        getCustomerClientAddress() {
            const customerClientAddress = _.get(this.site, "customerClientAddress");
            if (customerClientAddress && customerClientAddress !== "undefined") {
                const protocol = PRODUCTION ? "https" : "http";
                return `${protocol}://${customerClientAddress}?preview=1`;
            }
        },
    },
};
</script>

<style lang="scss">
.iframeContainer {
    .message-baloon {
        margin-top: 5px;
        margin-left: 20px;
        display: flex;
        justify-content: end;
    }
}
</style>
